// External Imports
import { connect } from 'react-redux';
import get from 'lodash/fp/get';
import omit from 'lodash/fp/omit';
import PropTypes from 'prop-types';
import React from 'react';

// Internal Imports
import { actionRequestNextPage } from '../../actions/index.js';
import { CampaignsTracker } from '../Tracking/CampaignsTracker.jsx';
import { createGetComponentByContentItem } from '../../selectors/createGetComponent.js';
import { createGetTranslation } from '../../selectors/i18n.js';
import { getLandingPage } from '../../selectors/getLandingPage.js';
import { getLandingPageShortcode } from '../../utils/metadata.js';
import { getLoading } from '../../selectors/index.js';
import { getMatch } from '../../selectors/getMatch.js';
import { HeaderLinks } from '../HeaderLinks/HeaderLinks.jsx';
import { LANDING_PAGE } from '../../config/types/prop.js';
import { Meta } from '../Meta/Meta.jsx';
import { options } from '../../config/reactRedux.js';
import { SINGLE } from '../../config/types/content/component.js';
import { WithLoader } from '../Hoc/WithLoader/WithLoader.jsx';

// Component Definition
function LandingPage(props) {
  const { component: LandingPageComponent, item, magazineEditionLanguage } = props;
  const {
    metadata: {
      link,
      languageHreflang,
      // headerMeta, // We need to pass it eventually through the API as we do for the Article Page
    },
  } = item;

  const { getTranslation } = props;

  const pageShortcode = getLandingPageShortcode(magazineEditionLanguage);

  const translatedTitle = getTranslation('meta-title', 'Babbel Magazine');
  const translatedDescription = getTranslation(
    'meta-description',
    'Real-life conversations start with stories that inspire.',
  );
  const metaDescription = { content: translatedDescription, name: 'description' };
  const metaTags = [metaDescription];

  return (
    <div>
      <Meta metaTags={metaTags} title={translatedTitle} />
      <CampaignsTracker shortlinkCode={pageShortcode} />
      <HeaderLinks canonicalUrl={link} languageHreflang={languageHreflang} />
      {/* eslint-disable-next-line react/jsx-props-no-spreading -- allow spread */}
      <LandingPageComponent {...omit(['component'], props)} />
    </div>
  );
}

LandingPage.propTypes = {
  component: PropTypes.elementType.isRequired,
  location: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types -- use TypeScript type eventually
  ...LANDING_PAGE,
};

const mapStateToProps = (state) => {
  const landingPage = getLandingPage(state);
  const loading = getLoading(state);
  const item = get('item', landingPage);
  const getComponent = createGetComponentByContentItem(item, SINGLE);
  const getTranslation = createGetTranslation(state);
  const component = getComponent(state);
  const magazineEditionLanguage = get('params.language', getMatch(state));

  return {
    ...landingPage,
    component,
    getTranslation,
    loading: loading.content || !component,
    loadingMore: loading.more,
    magazineEditionLanguage,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onLoadMore: (event) => {
    event.preventDefault();
    dispatch(actionRequestNextPage());
  },
});

const withRedux = connect(mapStateToProps, mapDispatchToProps, undefined, options);
const LandingPageHoc = withRedux(WithLoader(LandingPage));

// Module Exports
export { LandingPageHoc as LandingPage };
